// extracted by mini-css-extract-plugin
export default {"content":"Comment_content__wWmui","comment":"Comment_comment__YY388","nickAndAvatar":"Comment_nickAndAvatar__bUKEV","avatar":"Comment_avatar__0UDjz","nick":"Comment_nick__PljcD"};